export default __webpack_public_path__ + "static/media/createSeries.ae57c54a.svg";